import React, { useEffect, useState } from "react";
import { SketchPicker } from "react-color";

import "./Shadow.css";

const DropShadow = ({ setChartConfig, chartConfig }) => {
  const [enabled, setEnabled] = useState(chartConfig?.chart?.dropShadow?.enabled || false);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const dropShadow = chartConfig?.chart?.dropShadow || {};
  const { blur, left, top, color, opacity } = dropShadow;

  const handleDropShadowChange = (key, value) => {
    setChartConfig((prevConfig) => ({
      ...prevConfig,
      chart: {
        ...prevConfig.chart,
        dropShadow: {
          ...prevConfig.chart.dropShadow,
          [key]: value
        }
      }
    }));
  };

  const shadowEnabled = chartConfig?.chart?.dropShadow?.enabled;

  useEffect(() => {
    setEnabled(chartConfig?.chart?.dropShadow?.enabled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shadowEnabled]);

  return (
    <div className="drop-shadow-container">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="section-title">DropShadow</div>

        <div className="setting-row">
          <div
            style={{
              display: "flex",
              alignItems: "center"
            }}
          >
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={enabled}
                onChange={(e) => {
                  handleDropShadowChange("enabled", e.target.checked);
                  setEnabled(e.target.checked);
                }}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div>
      </div>

      {enabled && (
        <div className="settings">
          <div className="setting-row">
            <span className="setting-label">Blur</span>
            <input
              type="range"
              min="0"
              max="20"
              value={blur}
              onChange={(e) => handleDropShadowChange("blur", Number(e.target.value))}
            />
          </div>

          <div className="setting-row">
            <span className="setting-label">Offset X</span>
            <input
              type="range"
              min="-20"
              max="20"
              value={left}
              onChange={(e) => handleDropShadowChange("left", Number(e.target.value))}
            />
          </div>

          <div className="setting-row">
            <span className="setting-label">Offset Y</span>
            <input
              type="range"
              min="-20"
              max="20"
              value={top}
              onChange={(e) => handleDropShadowChange("top", Number(e.target.value))}
            />
          </div>

          <div className="setting-row">
            <span className="setting-label">Shadow Color</span>
            <div style={{ position: "relative" }}>
              <button className="color-picker-button" onClick={() => setShowColorPicker(!showColorPicker)}>
                <div className="color-swatch" style={{ backgroundColor: color }} />
                <span>{color}</span>
              </button>
              {showColorPicker && (
                <div className="picker-popover">
                  <div className="picker-cover" onClick={() => setShowColorPicker(false)} />
                  <SketchPicker color={color} onChange={(color) => handleDropShadowChange("color", color.hex)} />
                </div>
              )}
            </div>
          </div>

          <div className="setting-row">
            <span className="setting-label">Shadow Opacity</span>
            <input
              type="range"
              min="0"
              max="100"
              value={opacity * 100}
              onChange={(e) => handleDropShadowChange("opacity", Number(e.target.value) / 100)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DropShadow;
